export const prepareBookingForDuplication = (data) => {
  const isDuplicate = !!data.isDuplicate;
  delete data.isDuplicate;
  if (isDuplicate) {
    delete data.dateFrom;
    delete data.dateTo;
    data.bookingEntries?.forEach((entry) => {
      delete entry.bookedSlots;
      delete entry.allDay;
    });
  }
  return isDuplicate;
};

export const hazardousStatusGetter = (params) => {
  const status = params?.data?.approval?.status || params?.data?.hazardousStatus;
  return status?.toString().toUpperCase() || 'N/A';
}
